import { render, staticRenderFns } from "./Extended-Warranty.vue?vue&type=template&id=68b07610&scoped=true"
import script from "./Extended-Warranty.vue?vue&type=script&lang=js"
export * from "./Extended-Warranty.vue?vue&type=script&lang=js"
import style0 from "./Extended-Warranty.vue?vue&type=style&index=0&id=68b07610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b07610",
  null
  
)

export default component.exports